<template>
  <v-card>
    <v-card-title>
      Test 403
      <v-btn small icon @click="dataRefresh">
        <v-icon>refresh</v-icon></v-btn>
      <v-spacer></v-spacer>
    </v-card-title>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import AuthenticationService from '@/services/AuthenticationService'

  export default {
    data() {
      return {
        error: ''
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.error = ''
        (await AuthenticationService.test403()).data
      } catch (error) {
        this.error = this.handleError(error)
      }
    },
    methods: {
      async dataRefresh() {
        try {
          this.error = ''
          (await AuthenticationService.test403()).data
        } catch (error) {
          this.error = this.handleError(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DeveloperTesting/Test403.vue